import { ChartMode } from '@/types';

export interface ChartModeViewConfig {
    headingKeys: { perDay: string; perHour: string };
    labelKey: string;
}

/** Per-mode display metadata for the Weight tab: toggle label and chart heading translation keys. */
export const CHART_MODES: Record<ChartMode, ChartModeViewConfig> = {
    [ChartMode.GrowthIndex]: {
        headingKeys: {
            perDay: 'views.monitoring.charts.titles.growthIndexPerDay',
            perHour: 'views.monitoring.charts.titles.growthIndexPerHour',
        },
        labelKey: 'views.monitoring.charts.modes.growthIndex',
    },
    [ChartMode.DailyGain]: {
        headingKeys: {
            perDay: 'views.monitoring.charts.titles.dailyGainPerDay',
            perHour: 'views.monitoring.charts.titles.dailyGainPerHour',
        },
        labelKey: 'views.monitoring.charts.modes.dailyGain',
    },
    [ChartMode.Weight]: {
        headingKeys: {
            perDay: 'views.monitoring.charts.titles.weightPerDay',
            perHour: 'views.monitoring.charts.titles.weightPerHour',
        },
        labelKey: 'views.monitoring.charts.modes.weight',
    },
};

/** Display order of the modes in the toggle group. */
export const CHART_MODE_ORDER: ChartMode[] = [ChartMode.GrowthIndex, ChartMode.DailyGain, ChartMode.Weight];

export const DEFAULT_CHART_MODE: ChartMode = ChartMode.GrowthIndex;
